import { useTranslation } from "react-i18next";
import { Typography } from "../../../shared/ui";
import css from "./ChatToggle.module.scss";

interface ChatToggleProps {
  isOpen: boolean;
  onToggle: () => void;
  className?: string;
}

/** Кнопка-тогл над табами: открывает и закрывает чат одним и тем же местом. */
export function ChatToggle({
  isOpen,
  onToggle,
  className = "",
}: ChatToggleProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={`${css.toggle} ${isOpen ? css.open : ""} ${className}`}
      onClick={onToggle}
      aria-expanded={isOpen}
      aria-label={isOpen ? t("chat.close") : t("chat.open")}
    >
      {isOpen ? (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M2 2L14 14M14 2L2 14"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      ) : (
        <Typography variant="caption1" color="light-grey">
          {t("chat.title")}
        </Typography>
      )}
    </button>
  );
}
